import { PeriodReference, IPeriodConfiguration, TimeInterval, AggregationConfiguration, AggregationMode } from '../../models';
import { FlowChartSeries } from '../../widgets';

export class FlowChartConfiguration implements IPeriodConfiguration {
    aggregation: AggregationConfiguration;
    alignedOn: PeriodReference;
    backgroundUrl?: string;
    isEndDateIncluded: boolean;
    isZoomEnabled: boolean;
    minPeriod: TimeInterval;
    maxPeriod: TimeInterval;
    series: FlowChartSeries[];
    showAlarms?: boolean;
    showGrid?: boolean;

    constructor() {
        this.series = [];
        this.aggregation = new AggregationConfiguration();
        this.minPeriod = null;
        this.maxPeriod = null;
        this.alignedOn = 0;
        this.isEndDateIncluded = false;
        this.isZoomEnabled = false;
        this.aggregation.mode = AggregationMode.Average;
        this.aggregation.period.interval = 0;
    }
}

